import { render, staticRenderFns } from "./HeatmapRegistrationStep1.vue?vue&type=template&id=cb78da12&scoped=true"
import script from "./HeatmapRegistrationStep1.vue?vue&type=script&lang=js"
export * from "./HeatmapRegistrationStep1.vue?vue&type=script&lang=js"
import style0 from "./HeatmapRegistrationStep1.vue?vue&type=style&index=0&id=cb78da12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb78da12",
  null
  
)

export default component.exports